// --- 党员用户管理 --- //

export default [
  {
    name: 'partyMemberManagement',
    path: '/supplySystem/:supplyId/partyMemberManagement/list',
    meta: { title: '党员用户管理' },
    component: require('business/supplySystem/partyMemberManagement/list.vue').default
  }
]
